import { mergeStyles } from "@fluentui/merge-styles";
import { FONT_SIZE_SMALL } from "../../config/fontSizes";
import { tokens } from "@fluentui/react-components";

export const formStyles = mergeStyles({
  width: "100%",
});

export const stackColumnGap12 = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  alignItems: "flex-start",
});

export const stackColumnGap6 = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 6,
});

export const textareaClass = mergeStyles({
  fieldSizing: 'content',
  minHeight: 80,
  maxHeight: 200,
  width: "100%",
});

export const feedbackHeaderClass = mergeStyles({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const feedbackTitleClass = mergeStyles({
  fontWeight: 600,
  fontSize: tokens.fontSizeBase400,
  color: tokens.colorNeutralForeground1,
  margin: "0",
});

export const choiceGroupStyles = {
  flexContainer: {
    flexWrap: "nowrap",
    "& .ms-ChoiceField-field": {
      padding: "10px 0",
    },

    "& .ms-ChoiceFieldLabel": {
      fontSize: FONT_SIZE_SMALL,
    },

    "& .is-checked": {
      color: "#0078d4",
    },
    "& .ms-ChoiceField-field:before": {
      display: "none",
    },
    "& .ms-ChoiceField-field:after": {
      display: "none",
    },
  },
  field: { display: "flex", alignItems: "center", marginBottom: 10 },
  choiceFieldWrapper: { paddingLeft: 20 },
  innerField: { paddingRight: 8 },
  selectedIcon: {
    color: "#0078d4",
  },
};
